import { FC } from 'react';
import s from './storeItem.module.scss';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
interface Props {}
export const StoreItemLoading: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.storeItem} data-sentry-component="StoreItemLoading" data-sentry-source-file="StoreItemLoading.tsx">
            <Avatar srcSet={[{
      height: 40,
      width: 40,
      minMedia: 0
    }]} profile={undefined} isLoading={true} data-sentry-element="Avatar" data-sentry-source-file="StoreItemLoading.tsx" />
            <div className={s.storeItem__main}>
                <div className={cn(s.storeItem__name, '_ellipsis')}>
                    {tr({
          id: 'btn.loading'
        })}
                </div>
            </div>
            <div className={s.storeItem__right}>
            </div>
        </div>;
};